import { getLocalStorageItem } from './PromoCodeLocalStorage';

const getInitialState = () => ({
    value: getLocalStorageItem(),
});

export default getInitialState;
